import { NavLink } from 'react-router-dom';
import { ColourSwatch } from 'components/ColourSwatch/ColourSwatch';
import { Text, TextSpan } from 'components/CommonComponents';
import { Flexbox } from 'components/Flexbox';
import { COLOURS, PAD_EXTRA_LARGE_NUMBER, PAD_LARGE_NUMBER, PAD_SMALL_NUMBER } from 'providers/designSystem';

const ColourPalette = ({ colourPalette }) => {
    return (
        <Flexbox flexDirection="column" padding={PAD_SMALL_NUMBER} width="200px">
            <NavLink to={`/colour-palettes/${colourPalette.id}`}>
                <TextSpan>{colourPalette.name}</TextSpan>
                <Flexbox gap={PAD_SMALL_NUMBER}>
                    {colourPalette.colours.map((colour, index) => {
                        return (
                            <ColourSwatch
                                testId={`colour-swatch-${colour.id}`}
                                key={colour.id}
                                id={colour.id}
                                size={'sm'}
                                colour={colour}
                                onClick={() => null}
                            />
                        );
                    })}
                </Flexbox>
            </NavLink>
        </Flexbox>
    );
};

const ColourPalettesResult = ({ colourPalettes }) => {
    if (colourPalettes.length === 0) {
        return (
            <>
                <Text>No Colour Palettes</Text>
            </>
        );
    }

    return (
        <>
            {colourPalettes.map((colourPalette, index) => {
                return <ColourPalette key={index} colourPalette={colourPalette} />;
            })}
        </>
    );
};

export const ColourPalettes = ({ colourPalettes }) => {
    return (
        <Flexbox
            flexDirection="row"
            height="65vh"
            gap={PAD_EXTRA_LARGE_NUMBER}
            overflowY="scroll"
            padding={PAD_LARGE_NUMBER}
            border={`2px solid ${COLOURS.pink}`}
            // @ts-ignore
            borderRadius={[12, 0, 0, 12]}
        >
            <ColourPalettesResult colourPalettes={colourPalettes.result} />
        </Flexbox>
    );
};
